
const HeroSection = () => {
  return (
    <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://static.wixstatic.com/media/b85534_aef0eb0cce6d4811a7672a194af0c4f7~mv2.png/v1/fill/w_590,h_690,al_c,q_90,usm_0.66_1.00_0.01,enc_avif,quality_auto/b85534_aef0eb0cce6d4811a7672a194af0c4f7~mv2.png"
          alt="Infrared Therapy"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto">
        <h1 className="font-serif text-4xl md:text-6xl font-light text-white mb-6 leading-tight">
          Clinical Infrared Recovery Technology for Physical Therapy & Orthopedic Practices
        </h1>
        
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-4xl mx-auto leading-relaxed">
          U.S.-based distribution and support for advanced photobiomodulation systems — delivered with procurement-ready documentation, reliable logistics, and U.S. time-zone service.
        </p>
        
        <div className="w-16 h-16 mx-auto mb-8 flex items-center justify-center">
          <i className="ri-heart-pulse-line text-white text-5xl"></i>
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center gap-6 mb-8 text-sm text-white/80">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>U.S.-Based Support</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>Commercial & Clinical Use</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-white"></i>
            <span>Compliance Packet Available</span>
          </div>
        </div>

        {/* CTAs */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button className="bg-white text-gray-900 px-8 py-3 rounded-md text-sm font-medium hover:bg-gray-100 transition-all duration-300 cursor-pointer whitespace-nowrap">
            Request a Quote
          </button>
          <button className="border-2 border-white text-white px-8 py-3 rounded-md text-sm font-medium hover:bg-white hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap">
            Schedule a Facility Demo
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
